export default "<div class=\"blue\">\n    <div class=\"white\">\n        <app-expert-match-list></app-expert-match-list>\n    </div>\n</div>";